import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './GlobalPresence.css';

// DATA is correct
const LOCATIONS = [
  { id: 'surat', name: 'Surat HQ', city: 'Gujarat, India', coords: [72.8311, 21.1702] }
];

// ACCESS TOKEN is correct
mapboxgl.accessToken = "pk.eyJ1IjoiZ3Jpc2ZhYXMiLCJhIjoiY21iemNhd3FmMXdqaDJtb2o4ejRibTNseSJ9.7SGZ6pBZdjVIAqKi0pOi7g";

// --- THIS IS THE FIX: The updated map style object ---
const MAP_STYLE = {
    version: 8,
    name: "Visible Monochrome",
    glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
    sources: {
      mapbox: { type: 'vector', url: 'mapbox://mapbox.mapbox-streets-v8' },
    },
    layers: [
        // 1. A base background color (darkest)
        { id: 'background', type: 'background', paint: { 'background-color': '#111925' } },
        
        // 2. The land color, slightly lighter than the background to make it visible
        { 
          id: 'land', 
          type: 'fill', 
          source: 'mapbox', 
          'source-layer': 'land', 
          paint: { 'fill-color': '#1d354d' } // This is your primary blue color
        },
        
        // 3. The water color, different from both land and background
        { 
          id: 'water', 
          type: 'fill', 
          source: 'mapbox', 
          'source-layer': 'water', 
          paint: { 'fill-color': '#17263c' }
        }, 
        
        // Roads and Labels layers are okay and remain
        {
          id: 'roads',
          type: 'line',
          source: 'mapbox',
          'source-layer': 'road',
          paint: {
            'line-color': 'rgba(255, 255, 255, 0.1)', // Made roads more subtle
            'line-width': ['interpolate', ['linear'], ['zoom'], 8, 0.25, 16, 1.5], 
          },
        },
        {
          id: 'place-labels',
          type: 'symbol',
          source: 'mapbox',
          'source-layer': 'place_label',
          minzoom: 6,
          layout: {
            'text-field': ['get', 'name_en'],
            'text-size': ['interpolate', ['linear'], ['zoom'], 6, 10, 14, 16],
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'], 
            'text-allow-overlap': false
          },
          paint: {
            'text-color': '#ffffff',
            'text-halo-color': '#1d354d',
            'text-halo-width': 1.5,
          }
        }
    ],
};


// No changes needed for this function
const addPulsingDot = (mapInstance, location) => {
    const dotId = `pulsing-dot-${location.id}`;
    if (mapInstance.hasImage(dotId)) return;
    const size = 150, pulsingDot = {
      width: size, height: size, data: new Uint8Array(size * size * 4), context: null,
      onAdd: function() { const canvas = document.createElement('canvas'); canvas.width = this.width; canvas.height = this.height; this.context = canvas.getContext('2d'); },
      render: function() { const duration = 1500, t = (performance.now() % duration) / duration, radius = (size / 2) * 0.2, outerRadius = (size / 2) * 0.4 * t + radius; this.context.clearRect(0, 0, this.width, this.height); this.context.beginPath(); this.context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2); this.context.fillStyle = `rgba(255, 255, 255, ${1 - t})`; this.context.fill(); this.context.beginPath(); this.context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2); this.context.fillStyle = 'rgba(255, 255, 255, 0.9)'; this.context.fill(); this.data = this.context.getImageData(0, 0, this.width, this.height).data; mapInstance.triggerRepaint(); return true; }
    };
    mapInstance.addImage(dotId, pulsingDot, { pixelRatio: 2 });
    mapInstance.addSource(location.id, { type: "geojson", data: { type: "FeatureCollection", features: [{ type: "Feature", geometry: { type: "Point", coordinates: location.coords } }] } });
    mapInstance.addLayer({ id: location.id, type: "symbol", source: location.id, layout: { "icon-image": dotId, "icon-allow-overlap": true } });
    mapInstance.on('click', location.id, () => { new mapboxgl.Popup({ className: "monochrome-popup", closeButton: false, closeOnClick: true }).setLngLat(location.coords).setHTML(`<h3>${location.name}</h3><p>${location.city}</p>`).addTo(mapInstance); });
};

// No changes needed for the rest of the component
const GlobalPresence = () => {
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    if (map.current || !mapContainer.current) return;
    if (!mapboxgl.accessToken) {
      console.error("Mapbox access token is not set.");
      return;
    }

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: MAP_STYLE,
      center: [72.8311, 21.1702],
      zoom: 9,
      pitch: 20,
      antialias: true,
      scrollZoom: false,
    });
    
    map.current.on('load', () => {
      LOCATIONS.forEach(loc => addPulsingDot(map.current, loc));
    });
  }, []);

  const handleZoomIn = () => {
    if (!map.current) return;
    map.current.zoomIn({ duration: 300 });
  };
  const handleZoomOut = () => {
    if (!map.current) return;
    map.current.zoomOut({ duration: 300 });
  };

  return (
    <div className="presence-section-wrapper">
      <div className="main-viewport">
        <div ref={mapContainer} className="map-renderer-canvas" />
        <div className="map-controls">
          <button className="map-control-button" onClick={handleZoomIn} aria-label="Zoom in">+</button>
          <button className="map-control-button" onClick={handleZoomOut} aria-label="Zoom out">−</button>
        </div>
        <div className="viewport-scanline-effect"></div>
      </div>
    </div>
  );
};

export default GlobalPresence;